import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.' + environment.brand + '.html',
    styleUrls: ['./dialog.component.' + environment.brand + '.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DialogComponent {
    @Input() header = '';
    @Input() message = '';

    @Input()
    get visible(): boolean { return this._visible; }
    set visible(value: boolean) {
        this._visible = value;
        this.visibleChange.emit(this._visible);
    }
    private _visible = false;

    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() closeDialog = new EventEmitter<void>();

    onCloseDialog(): void {
        this.visible = false; // will trigger onHide()
    }

    onHideDialog(): void {
        this.visible = false;
        this.closeDialog.emit();
    }
}
